import React, { Component } from 'react';

/**
 * Test component for testing/demoing library bootstrapping. Delete once we have something productive
 */
export default class TestComponent2 extends Component {
  render() {
    return <div>{'Another lib component!'}</div>;
  }
}
